/**
 * Command-center endpoint on Skynet.Pricing (DEV-4096).
 *
 * - GET /api/command-center/rate-sheet/movement — bucket-level rate movement vs prior publish.
 * - GET /api/command-center/desk-status — Margin Center MC-3 (DEV-4970): per-channel published-vs-
 *   candidate rate sheet version plus the maker-checker publish state of the channel's most recent
 *   margin change request.
 *
 * Company-scoped by JWT; may 404 when Pricing has not yet deployed the endpoint — the
 * calling action degrades gracefully to null. getDeskStatus also skips the global forbidden-reload:
 * a 403 degrades to null instead of triggering a full-page reload.
 */
import { SKIP_FORBIDDEN } from './httpConfig';

export class CommandCenterPricingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getRateSheetMovement({ config = {} } = {}) {
    return this.#http.get('/api/command-center/rate-sheet/movement', config);
  }

  async getDeskStatus() {
    return this.#http.get('/api/command-center/desk-status', SKIP_FORBIDDEN);
  }
}
